// Bottom nav compartido por las pantallas del paciente (HomePaciente,
// ProgresoPaciente, HistorialSesiones, PerfilPaciente futuro). Antes
// estaba duplicado inline en cada pantalla con variaciones (algunas
// centered, otras full-width; estados activos manejados distinto).
// Extracción hecha en bloque D — el síntoma de inconsistencia entre
// copias se materializó cuando arrancamos el responsive: el de
// HomePaciente estaba centered, los otros dos full-width.
//
// Active state se deriva de useLocation, no recibe prop. Si una pantalla
// futura necesita comportamiento distinto (ej. nav que NO destaca un
// item porque la pantalla actual no está en el listado), agregamos prop
// opcional `activeOverride`.

import { Link, useLocation } from "react-router";
import { Clock, Home, TrendingUp, User } from "lucide-react";

const items = [
  { path: "/paciente-home", Icon: Home, label: "Inicio" },
  { path: "/progreso", Icon: TrendingUp, label: "Progreso" },
  { path: "/historial", Icon: Clock, label: "Historial" },
  { path: "/perfil", Icon: User, label: "Perfil" },
];

export function PacienteBottomNav() {
  const { pathname } = useLocation();
  return (
    // Sprint 3 B4c: bottom nav se oculta en lg: (desktop) porque las
    // pantallas paciente responsive usan PacienteSidebar en su lugar.
    // Mobile (< lg:) mantiene el comportamiento original 100% intacto.
    // Caveat: mientras ProgresoPaciente/HistorialSesiones/PerfilPaciente
    // NO estén adaptadas al layout desktop, quedan sin nav en lg: (ver
    // deuda técnica "Adaptar Progreso/Historial/Perfil al layout desktop").
    <nav className="lg:hidden fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-card border-t border-border pb-[env(safe-area-inset-bottom)]">
      <div className="flex justify-around px-2 pt-2 pb-2">
        {items.map((i) => {
          const on = i.path === pathname;
          return (
            <Link
              key={i.path}
              to={i.path}
              className="flex flex-col items-center gap-1 px-4 py-1.5 min-w-[56px]"
            >
              <i.Icon
                className={`h-[22px] w-[22px] ${on ? "text-primary" : "text-muted-foreground"}`}
                strokeWidth={on ? 2.3 : 2}
              />
              <span
                className={`text-[10px] font-semibold ${on ? "text-primary" : "text-muted-foreground"}`}
              >
                {i.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
